import { Component } from "@angular/core";
import { HeaderComponent } from "../dashboard/header/header.component";

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.scss"],
  standalone: true,
  imports: [HeaderComponent],
})
export class NotFoundComponent {}
